module.exports = __webpack_public_path__ + "img/Rooms_text02_tablesAZ.a89d3a8e.png";